<template>
	<v-app style="overflow-x:hidden; font-family: 'Roboto', sans-serif;">
		<PersistentNavbar @activateNav="$refs.navbar.trigger()" />
		<NavigationDrawer ref="navbar" />
		<v-main id="main">
			<v-container fluid class="pa-0">
				<v-row no-gutters>
					<v-col cols="12" class="pa-0">
						<router-view :loading="loading" />
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<PersistentFooter :leftMenuBarTrigger="$refs.navbar?.active" />
		<div class="scroll-to-top">
			<v-col class="pa-0 d-flex flex-column" cols="auto">
				<v-btn class="mb-2" v-if="isShow" fab small color="#ffeb3b" @click="clickScrollToTop">
					<v-icon>mdi-arrow-collapse-up</v-icon>
				</v-btn>
				<!-- <v-btn v-if="isShow" fab color="#ffeb3b" @click="clickScrollToBottom">
					<v-icon>mdi-arrow-collapse-down</v-icon>
				</v-btn> -->
			</v-col>
		</div>
	</v-app>
</template>

<script>
import PersistentNavbar from "@/components/PersistentNavbar";
import PersistentFooter from "@/components/PersistentFooter";
import NavigationDrawer from "@/refactor/components/NavigationDrawer.vue";

export default {
	name: "App",
	components: {
		NavigationDrawer,
		PersistentFooter,
		PersistentNavbar,
	},
	data: () => ({
		navbar: false,
		timer: null,
		loading: false,
		isShow: false,
		unreadCountIntervalId: null,
		prefsKey: 'prefs',
	}),
	methods: {
		pollUser() {
			this.$store.dispatch('user/getUser');
		},
		initBookmarks() {
			this.$store.dispatch('api/bookmarks/initBookmarks', {});
		},
		initNotificationsCount() {
			this.$store.dispatch('api/inbox/requestUnreadCount');
		},
		clickScrollToTop() {
			this.$helpers.scrollTo(0);
		},
		clickScrollToBottom() {
			let footerHeight = this.cellphone ? 1400 : 800;
			const scrollPosition = document.documentElement.scrollHeight - footerHeight;
			this.$helpers.scrollTo(scrollPosition);
		},
		handleScroll() {
			this.isShow = window.scrollY > 400;
		},
		startInterval() {
			this.unreadCountIntervalId = setInterval(this.initNotificationsCount, 30000);
		},
		stopInterval() {
			clearInterval(this.unreadCountIntervalId);
			this.unreadCountIntervalId = null;
		},
		addNoIndexMetaTag() {
			const meta = document.createElement('meta');
			meta.name = 'robots';
			meta.content = 'noindex, nofollow';
			document.getElementsByTagName('head')[0].appendChild(meta);
		},
		getCurrentNetwork() {
			this.$store.dispatch('api/network/getSelfNetwork').then((res) => {
				if (res.status === 200) {
					if (res.data.country_code) {
						if (this.prefs?.country_code !== res.data.country_code) {
							let prefsValue = {
								...this.prefs,
								country_code: res.data.country_code,
								country_name: res.data.country_name
							}

							this.$store.commit("settings/setPrefs", prefsValue);
							this.$store.dispatch("settings/loadSettings", { code: prefsValue.country_code })
						}
					} else {
						let prefsValue = {
							...this.prefs,
							country_code: "CA",
							country_name: "Canada"
						}

						this.$store.commit("settings/setPrefs", prefsValue);
						this.$store.dispatch("settings/loadSettings", { code: prefsValue.country_code })
					}
				}
			}).catch((err) => {
				const { status, message } = err.response?.data || {};
				// this.$toasted.error(`Fail to fetch self network: ${status ? "Error Code: " + status + "," : ""} ${message || err}`);
				console.log(`Fail to fetch self network: ${status ? "Error Code: " + status + "," : ""} ${message || err}`)
			}).finally(() => {

			})
		},
	},
	computed: {
		mobile() {
			return this.$vuetify.breakpoint.mobile;
		},
		cellphone() {
			return this.$vuetify.breakpoint.xs;
		},
		loggedIn() {
			return this.$store.getters['user/getLoggedIn'];
		},
		user() {
			return this.$store.getters['user/getUser'];
		},
		isLive() {
			console.log("checking live...")
			return window.location.origin === 'https://www.bestrealestatebuy.com';
		},
		isMerchant() {
			return this.$helpers.hasMerchantCreate(this.$store);
		},
		prefs() {
			return this.$store.getters["settings/getPrefs"];
		},
	},
	created() {
		if (!this.isLive) {
			console.log("It is not live env...")
			this.addNoIndexMetaTag();
		}

		this.loading = true;
		const fetchUserAndShops = async () => {
			await this.$store.dispatch('user/getUser');
			if (this.loggedIn) {
				this.$store.dispatch('api/rule/getAllNewMatched', { user: this.user });
				this.$store.dispatch('api/shop/getShops');
				this.$store.dispatch('api/cart/getCart');
				this.$store.dispatch('api/inbox/requestUnreadCount');
				this.$store.dispatch('api/plan/getSelfAccountPlan');
				this.$store.dispatch('api/file/getMetadataStats');
				await this.$store.dispatch('api/acl/getGroupsForSelf').then(() => {
					if (this.isMerchant) {
						this.$store.dispatch('api/billboard/getBillboardUsageSummary');
					}
				});
			}
			this.loading = false;
		};

		window.setTimeout(() => {
			window.setInterval(this.pollUser, 300000);
		}, 20000);

		fetchUserAndShops();
		this.$helpers.scrollToTop();
	},
	updated() {

	},
	watch: {
		'$vuetify.breakpoints.mobile'() {
			this.navbar = false;
		},
		loggedIn(v) {
			if (v) {
				this.initBookmarks();
				this.startInterval();
			} else {
				this.stopInterval();
			}
		},
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
		this.getCurrentNetwork();
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
		this.stopInterval();
	},
};
</script>

<style lang="css">
@import "//fonts.googleapis.com/css?family=Roboto:400,500,700,400italic|Material+Icons";

::-webkit-scrollbar {
	width: 10px;
}

::-webkit-scrollbar-track {
	background: #0b4073;
}

::-webkit-scrollbar-thumb {
	background: #5d8cb9;
}

::-webkit-scrollbar-thumb:hover {
	background: #b6b6b6;
}

.v-application {
	padding: 0 !important;
}

.v-application .primary--text {
	color: white !important;
}

.v-divider {
	margin: 25px;
}

.v-application a {
	text-decoration: none;

	color: inherit;
}

.scroll-to-top {
	position: fixed;
	bottom: 100px;
	right: 20px;
	z-index: 3;
}
</style>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0");
</style>